import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=160035fa&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=ts"
export * from "./Groups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160035fa",
  null
  
)

export default component.exports